const IMAGE_EXTENSION_RE = /\.(jpe?g|png|gif|webp|svg|bmp|avif)(\?.*)?$/i;
const DEFAULT_EXTENSION = "jpg";

export const EXTERNAL_FOOD_IMAGE_FALLBACK = "/img/new-icons/broken-img.svg";

export function resolveExternalFoodImageUrl(image, imageType) {
  if (image == null || image === "") return null;

  let url = String(image).trim();
  if (!url) return null;

  if (IMAGE_EXTENSION_RE.test(url)) return url;

  url = url.replace(/\.+$/, "");

  const ext =
    String(imageType ?? DEFAULT_EXTENSION)
      .trim()
      .replace(/^\./, "") || DEFAULT_EXTENSION;

  return `${url}.${ext}`;
}
